// v13
// Path: frontend/src/components/QuickBooksSync/FieldMappingModal.jsx
// Inputs: token, config, onClose, onSaved
// Outputs: React JSX modal for pipeline field mappings
// Summary: Modal container wrapping the unified FieldMappingDesigner for pipeline-specific field mappings and live sample introspection with dynamic key re-mounting and sourceSystem pass-through.

import React from 'react';
import { FieldMappingDesigner } from './FieldMappingDesigner';

export const FieldMappingModal = ({ token, config, onClose, onSaved }) => {
    if (!config) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4 overflow-y-auto">
            <div className="bg-slate-900 border border-slate-700 rounded-2xl w-full max-w-6xl shadow-2xl flex flex-col h-[92vh] overflow-hidden">
                <FieldMappingDesigner
                    key={`modal_designer_${config.ConfigID || config.TargetQBEntity}`}
                    mode="pipeline"
                    token={token}
                    config={config}
                    sourceSystem={config.SourceSystem || 'Passport'}
                    onClose={onClose}
                    onSaved={onSaved}
                />
            </div>
        </div>
    );
};

export default FieldMappingModal;
